//import React, { useContext } from 'react'
import React,{ useEffect ,Suspense} from "react";
import axios from "axios";

//import TopSlider from '../components/home/TopSlider';
const TopSlider = React.lazy(() => import('../components/home/TopSlider'));


//import MarqueeText from '../components/home/MarqueeText';
const MarqueeText = React.lazy(() => import('../components/home/MarqueeText'));
//import HotCategories from '../components/home/HotCategories';
const HotCategories = React.lazy(() => import('../components/home/HotCategories'));
//import CategoriesSlider from '../components/home/CategoriesSlider';
const CategoriesSlider = React.lazy(() => import('../components/home/CategoriesSlider'));
//import TextWithImage from '../components/home/TextWithImage';
const TextWithImage = React.lazy(() => import('../components/home/TextWithImage'));
//import TextWithTwoImages from '../components/home/TextWithTwoImages';
const TextWithTwoImages = React.lazy(() => import('../components/home/TextWithTwoImages'));
//import Clients from '../components/Layout/Clients';
const Clients = React.lazy(() => import('../components/Layout/Clients'));
import { useAppContext } from "../Context/Store";

//import { useEffect, useState } from "react";
//import { AppContext } from '../Context/Store';


export default function Home({ sendBodyClass }) {
  

  //const contextData = useAppContext(); 
  const { isError, isLoading, HomeData, myName } = useAppContext(); 
 
//   const getHomeDATA= async () => {
 
//     axios.get('https://abbastahir-001-site1.qtempurl.com/umbraco/delivery/api/v2/content/?fetch=children:dd1975e1-c750-40e3-9645-9fdff2a4a55f',
//       { auth: {
//     username: '11202953',
//     password: '60-dayfreetrial'
//   }})
//   .then(response => {
//     //console.log('Success response:', response);
//     const HomeData = response.data;
//     console.log("Get home data", HomeData); 
//   })
//   .catch(error => {
//     if (error.response) {
//       // The server responded with a status code outside the 2xx range
//       console.log('Error response:', error.response);
//     } else if (error.request) {
//       // The request was made but no response was received
//       console.log('Error request:', error.request);
//     } else {
//       // Something happened in setting up the request that triggered an error
//       console.log('Error message:', error.message);
//     }
//   });
  
// }

useEffect(() => {
  sendBodyClass(false);
},[])

  // //Home Home Top Slider 
  //   const TopSliderData = [
  //     {
  //       id: 1, 
  //       Mainimage: '/images/hero-img1.jpg',
  //       Mainimagemobile: '/images/hero-img1-m.jpg',
  //       Mainimagealt: 'The Smart Business Hub',
  //       boolean: true
  //     },
  //     {
  //       id: 2, 
  //       Mainimage: '/images/main-slider2.jpg',
  //       Mainimagemobile: '/images/main-slider2-m.jpg',
  //       Mainimagealt: 'The Smart Business Hub',
  //       boolean: true
  //     },
  //     {
  //       id: 3, 
  //       Mainimage: '/images/main-slider3.jpg',
  //       Mainimagemobile: '/images/main-slider3-m.jpg',
  //       Mainimagealt: 'The Smart Business Hub',
  //       boolean: true
  //     }
  //   ];
  // //End

    // const MarqueeTextData = {
    //     id: 1, 
    //     Text: 'Corporate Giveaways 24/7 · ', 
    //     boolean: true
    // };

    // const HotCategoriesData = 
    //   {
    //       id: 1, 
    //       TopHeading: 'The ultimate guide to choosing memorable corporate gifts', 
    //       BottomHeading: 'Corporate business gifts with custom engraving', 
    //       HotCategoriesList: [
    //           {Id: 1, Category: 'Giveaways', Subcategory: 'Luxury Giveaway Box', Url: '/giveaways-bundle'},
    //           {Id: 2, Category: 'Diaries', Subcategory: 'Textured Diary', Url: '/diaries'},
    //           {Id: 3, Category: 'Awards', Subcategory: 'Crystal Awards', Url: '/awards-shields'},
    //           {Id: 4, Category: 'Bags', Subcategory: 'Goodie Bag', Url: '/bags'},
    //           {Id: 5, Category: 'Mugs', Subcategory: 'Coffee Mug', Url: '/mugs'},
    //           {Id: 6, Category: 'Pens', Subcategory: 'Effortless Pen', Url: '/pens'}
    //       ],
    //   };
    // //End

    // const CategoriesSliderData = 
    //   {
    //       id: 1, 
    //       TopHeading: 'Explore our exciting range of <span>giveaways</span> designed to captivate your <span>audience</span> and elevate your <span>brand</span> presence. ', 
    //       Categorieslist: [{
    //           Id: 1, 
    //           Image: '/images/img-slide7.jpg', 
    //           Category: 'Giveaways', 
    //           Subcategory: 'Luxury Giveaway Box', 
    //           Url: '/giveaways-bundle'
    //         },{
    //           Id: 2, 
    //           Image: '/images/img-slide10.jpg', 
    //           Category: 'Bags', 
    //           Subcategory: 'Canvas Bag', 
    //           Url: '/bags'
    //         },{
    //           Id: 3, 
    //           Image: '/images/img-slide9.jpg', 
    //           Category: 'Diaries', 
    //           Subcategory: 'Pocket Size Diary', 
    //           Url: '/diaries'
    //         },{
    //           Id: 4, 
    //           Image: '/images/img-slide12.jpg', 
    //           Category: 'Mugs', 
    //           Subcategory: 'Executive Mug', 
    //           Url: '/mugs'
    //         },{
    //           Id: 5, 
    //           Image: '/images/img-slide11.jpg', 
    //           Category: 'Bottles', 
    //           Subcategory: 'Temperature Water Bottle', 
    //           Url: '/bottles'
    //         },{
    //           Id: 6, 
    //           Image: '/images/img-slide3.jpg', 
    //           Category: 'Awards', 
    //           Subcategory: 'Unique 3D Award', 
    //           Url: '/awards-shields'
    //         }
    //       ],
    //   };
    // //End

    // const TextWithImageData = {
    //     id: 1, 
    //     Image: '/images/img-two-column.jpg', 
    //     Heading: 'Create memorable <br /><span>giveaways</span>', 
    //     Description: '<p>Using a mix of these ideas can create a memorable and effective corporate giveaway that strengthens your brand\'s relationship with clients and employees!</p><p>For your convenience, flexibility and security.</p>', 
    // };


    // const TextWithTwoImageData = 
    //   {
    //       id: 1, 
    //       Heading: 'Elevate your brand with<br /><span>Thoughtful Giveaways', 
    //       Description: '<p>Our goal is to provide items that are useful, memorable, and align with your brand.</p>', 
    //       ImageLeft: '/images/img-left-gift.jpg',
    //       ImageRight: '/images/img-right-gift.jpg',
    //       SubSection: [
    //           {
    //             Id: 1, 
    //             SubHeading: '<h3>Access to our 4000 product catalogue</h3>', 
    //             SubDescription: '<p>You can sourcing items for corporate gifting, or retail purposes, our comprehensive catalogue provides an variety, and quality in one place.</p>', 
    //           },
    //           {
    //             Id: 2, 
    //             SubHeading: '<h3>Deliver more than 10000 gifts</h3>', 
    //             SubDescription: '<p>Our commitment to exceptional service has enabled to deliver over 10,000 curated gifts, building connections around the world. </p>', 
    //           },
    //           {
    //             Id: 3, 
    //             SubHeading: '<h3>Product customization as per request</h3>', 
    //             SubDescription: '<p>Experience the flexibility of our customization process and transform standard products into ones that reflect your unique style and needs.</p>', 
    //           },
    //           {
    //             Id: 4, 
    //             SubHeading: '<h3>Decades of our experience</h3>', 
    //             SubDescription: '<p>We bring a wealth of knowledge, skill, and innovation to every project.</p>', 
    //           },
    //       ],
    //       ButtonsUrl: [{
    //           Id: 1, 
    //           Text: 'FAQs',
    //           Url: '/faqs',  
    //         },
    //         {
    //           Id: 2,  
    //           Text: 'Our products',
    //           Url: '/category', 
    //         }
    //     ],
    //   };

    //   const ClientsData = [
    //     {id: 1, ImageLogo: '/images/client-logo1-b.svg'},
    //     {id: 2, ImageLogo: '/images/client-logo2-b.svg'},
    //     {id: 3, ImageLogo: '/images/client-logo3-b.svg'},
    //     {id: 4, ImageLogo: '/images/client-logo4-b.svg'},
    //     {id: 5, ImageLogo: '/images/client-logo5-b.svg'},
    //     {id: 6, ImageLogo: '/images/client-logo1-b.svg'},
    //     {id: 7, ImageLogo: '/images/client-logo2-b.svg'},
    //     {id: 8, ImageLogo: '/images/client-logo3-b.svg'},
    //     {id: 9, ImageLogo: '/images/client-logo4-b.svg'},
    //     {id: 10, ImageLogo: '/images/client-logo5-b.svg'},
    //     {id: 11, ImageLogo: '/images/client-logo1-b.svg'},
    //     {id: 12, ImageLogo: '/images/client-logo2-b.svg'},
    //     {id: 13, ImageLogo: '/images/client-logo3-b.svg'},
    //     {id: 14, ImageLogo: '/images/client-logo4-b.svg'},
    //     {id: 15, ImageLogo: '/images/client-logo5-b.svg'}
    //   ];

      if(isError){
        //console.log("Home Page Component", contextData); 
        return <div>Error Home Page...</div>;  // Handle Error state
      }

      // if (isLoading) {
      //   return <div>Loading 1...</div>;  // Handle loading state
      // }
      // if(contextData.isLoading){
      //   return <div>Loading...</div>;
      // }
 
      //console.log("Home Page Component", contextData);

      const { properties } = HomeData;

      //console.log(properties?.leftText?.markup);
      //console.log(properties?.rightImage);

  return (
    <>
    <Suspense fallback={<div>Loading...</div>}>
      <TopSlider 
        SliderDataDynamic={properties?.topSlider?.items || "Top Slider Data Missing"}
      />
      <MarqueeText 
        MarqueeTextDataDynamic={properties?.marqueeText || "Marquee Text Data Missing"}
      />
      <HotCategories 
        HotCategoriesDataDynamicTopText={properties?.topText || "Hot Category Top Text Data Missing"} 
        HotCategoriesDataDynamicBottomText={properties?.bottomText || "Hot Category Bottom Text Data Missing"} 
        HotCategoriesDataDynamic={properties?.hotCategories || "Hot Categories Data Missing"} 
      />
      <CategoriesSlider 
        CategoriesSliderDataDynamic={properties?.categoriesItems || "Categories Slider Data Missing"} 
      />
      <TextWithImage 
        LeftTextDataDynamic={properties?.leftText?.markup || "TextWithImage Left Text Data Missing"} 
        RightImageDataDynamic={properties?.rightImage || "TextWithImage Right Image Data Missing"} 
      />
      <TextWithTwoImages 
        BrandLeftTextDataDynamic={properties?.brandLeftText || "Brand Left Text Data Missing"} 
        BrandRightImageDataDynamic={properties?.brandRightImage || "Brand Right Image Data Missing"} 
        BrandCenterTopTextDataDynamic={properties?.brandCenterTopText || "Brand Center Top Text Data Missing"} 
        BrandCenterTextDataDynamic={properties?.brandCenterText?.markup || "Brand Center Text Data Missing"} 
        BrandLeftBottomImageDataDynamic={properties?.brandLeftBottomImage || "Brand Left Bottom Image Data Missing"} 
      />
      <Clients 
        OurClientItemsDataDynamic={properties?.ourClientItems?.items || "Clients Slider Data Missing"} 
      />

</Suspense>
    </>
  )
}
